import * as React from 'react';
import { ComponentType } from 'react';
import { connect } from "react-redux";
import RouterHoc, { IRouterActions, IRouterProps } from 'src/hoc/RouterHoc';
import { RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { RequestState } from "../../../enumerations/RequestState";
import { TrialSubMenu } from '../../../helpers/subMenuHelper';
import { ITmdState } from "../../../reducers/index";
import './TrialLayout.scss';

interface ITrialLayoutParams {}

interface ITrialLayoutProps extends IRouterProps<ITrialLayoutParams> {
    // From state
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    trial?: Dtos.Trial;

    loadingTrial?: boolean;

    loading?: boolean;
    children?: any;
}

interface ITrialLayoutActions extends IRouterActions {}

type TrialLayoutProps = ITrialLayoutProps & ITrialLayoutActions;

class TrialLayout extends React.PureComponent<TrialLayoutProps, any> {

    constructor(props: TrialLayoutProps) {
        super(props);
    }

    render() {

        const {
            loadingTrial,
            trial,
            loading,
            permissions,
            permission
        } = this.props;

        return (
            <RestrictedLayout
                permission={permission}
                trialId={trial ? trial.id : null}
                subMenuTitle={trial ? trial.shortDisplay : ""}
                subMenuItems={loadingTrial == undefined || !trial ? [] : TrialSubMenu(trial.id, permissions)}
                loading={loadingTrial || loading}
            >
                {this.props.children}
            </RestrictedLayout>
        );
    }

}


const mapStateToProps = (state: ITmdState, ownProps: TrialLayoutProps): ITrialLayoutProps => {

    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        history: ownProps.history,
        location: ownProps.location,

        permissions: permissions,
        permission: ownProps.permission,

        trial: trial!,

        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,

        loading: ownProps.loading,
        children: ownProps.children,
    };
};

const mapDispatchToProps = (dispatch, ownProps: TrialLayoutProps): ITrialLayoutActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,
    };
};

export default
    RouterHoc<ITrialLayoutParams, TrialLayoutProps>((connect(mapStateToProps, mapDispatchToProps)(TrialLayout) as unknown as ComponentType<TrialLayoutProps>)) as ComponentType<any>;
